module.exports = new __parcel__URL__("feature-8.1a310359.png").toString();